import _classCallCheck from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/createClass.js";
/* eslint-disable */

import { deepMix, each, wrapBehavior } from '@antv/util';
import { modifyCSS } from '@antv/dom-util';
var Toolbar = /*#__PURE__*/function () {
  function Toolbar(cfgs) {
    _classCallCheck(this, Toolbar);
    this._cfgs = deepMix(this.getDefaultCfg(), cfgs);
  }
  _createClass(Toolbar, [{
    key: "getDefaultCfg",
    value: function getDefaultCfg() {
      return {
        container: null
      };
    }
  }, {
    key: "get",
    value: function get(key) {
      return this._cfgs[key];
    }
  }, {
    key: "set",
    value: function set(key, val) {
      this._cfgs[key] = val;
    }
  }, {
    key: "initPlugin",
    value: function initPlugin(graph) {
      var self = this;
      this.set('graph', graph);
      var events = self.getEvents();
      var bindEvents = {};
      each(events, function (v, k) {
        var event = wrapBehavior(self, v);
        bindEvents[k] = event;
        graph.on(k, event);
      });
      this._events = bindEvents;
      this.initEvents();
      this.updateToolbar();
    }
  }, {
    key: "getEvents",
    value: function getEvents() {
      return {
        afteritemselected: 'updateToolbar',
        aftercommandexecute: 'updateToolbar'
      };
    }
  }, {
    key: "initEvents",
    value: function initEvents() {
      var graph = this.get('graph');
      var parentNode = this.get('container');
      var children = parentNode.querySelectorAll('div > span[data-command]');
      each(children, function (child, i) {
        var cmdName = child.getAttribute('data-command');
        child.addEventListener('click', function (e) {
          graph.commandEnable(cmdName) && graph.executeCommand(cmdName);
        });
      });
    }
  }, {
    key: "updateToolbar",
    value: function updateToolbar() {
      var graph = this.get('graph');
      var parentNode = this.get('container');
      var children = parentNode.querySelectorAll('div > span[data-command]');
      each(children, function (child, i) {
        var cmdName = child.getAttribute('data-command');
        if (graph.commandEnable(cmdName)) {
          modifyCSS(child, {
            cursor: 'pointer'
          });
          modifyCSS(child.children[0], {
            color: '#666'
          });
          child.children[0].setAttribute('color', '#666');
        } else {
          modifyCSS(child, {
            cursor: 'default'
          });
          modifyCSS(child.children[0], {
            color: '#bfbfbf'
          });
          child.children[0].setAttribute('color', '#bfbfbf');
        }
      });
    }
  }, {
    key: "destroyPlugin",
    value: function destroyPlugin() {
      this.get('canvas').destroy();
      var container = this.get('container');
      container.parentNode.removeChild(container);
    }
  }]);
  return Toolbar;
}();
export default Toolbar;